import {
  SHOW_ASSETS_MODAL,
  HIDE_ASSETS_MODAL,
  UPLOAD_ASSET_FAILURE,
  UPLOAD_ASSET_REQUEST,
  UPLOAD_ASSET_SUCCESS,
  FETCH_ASSETS_REQUEST,
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAILURE,
  DELETE_ASSET_REQUEST,
  DELETE_ASSET_SUCCESS,
  DELETE_ASSET_FAILURE,
  UPDATE_ASSET_REQUEST,
  UPDATE_ASSET_SUCCESS,
  UPDATE_ASSET_FAILURE,
} from '../../constant';
import { modalOpen } from '../../helpers/utils';

const initialState = {
  assetsModalProps: {
    open: false,
    loading: false,
    uploadError: null,
    loadError: null,
    uploading: false,
    assets: [],
    selectedAsset: null,
  },
};

const assets = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ASSETS_MODAL:
    case HIDE_ASSETS_MODAL: {
      let tempObj = { ...state.assetsModalProps, open: action.open };
      modalOpen(action.open);
      return {
        ...state,
        assetsModalProps: tempObj,
      };
    }
    case UPLOAD_ASSET_REQUEST:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          uploading: true,
          uploadError: null,
        },
      };
    case UPLOAD_ASSET_SUCCESS:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          uploading: false,
          assets: [...state.assetsModalProps.assets, action.payload],
        },
      };
    case UPLOAD_ASSET_FAILURE:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          uploading: false,
          uploadError: action.error,
        },
      };
    case FETCH_ASSETS_REQUEST:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          loading: true,
          loadError: null,
          assets: [],
        },
      };
    case FETCH_ASSETS_SUCCESS:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          loading: false,
          assets: action.payload,
        },
      };
    case FETCH_ASSETS_FAILURE:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          loading: false,
          loadError: action.error,
        },
      };
    case DELETE_ASSET_REQUEST:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
        },
      };
    case DELETE_ASSET_SUCCESS:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          assets: state.assetsModalProps.assets.filter((asset) => asset.id !== action.payload),
        },
      };
    case DELETE_ASSET_FAILURE:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
        },
      };
    case UPDATE_ASSET_REQUEST:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          saving: true,
          updateError: null,
        },
      };
    case UPDATE_ASSET_SUCCESS:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          saving: false,
          assets: state.assetsModalProps.assets.map((asset) =>
            asset.id === action.payload.id ? action.payload : asset,
          ),
        },
      };
    case UPDATE_ASSET_FAILURE:
      return {
        ...state,
        assetsModalProps: {
          ...state.assetsModalProps,
          saving: false,
          updateError: action.error,
        },
      };
    default:
      return state;
  }
};

export default assets;
